

function getFormatedPrice(price?: number | string, unities?:number) {
    const finalPrice = (price! > 1 && unities && unities > 1) ? Number(price!) * unities : price;
    const formatedPrice = `R$ ${finalPrice!.toString().replace(".", ",")}`;
    return formatedPrice;
}


export { getFormatedPrice }